import { ChangeDetectionStrategy, Component, forwardRef, input, InputSignal } from '@angular/core';
import { FilterInputBase } from '../filter-input.base';
import { FilterConfig, FilterItemConfig } from '../../../../types/filter-config';
import { Entity, QueryColumnFilter, QueryFilter } from '@softline/core';
import { Filter } from '../../../../types/filter';
import { PageFilterDataService } from '../../../services/data-source/page-filter-data.service';

@Component({
  selector: 'soft-select-filter',
  imports: [],
  templateUrl: './select-filter-input.component.html',
  styleUrl: './select-filter-input.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    { provide: FilterInputBase, useExisting: forwardRef(() => SelectFilterInputComponent) }
  ]
})
export class SelectFilterInputComponent<T extends object> extends FilterInputBase<T, 'equals' | 'notEquals'> {

  override readonly item = input.required<FilterItemConfig<T>>();
  override readonly itemFilter = input.required<(Filter<T> & { operator: "equals" | "notEquals" }) | null>();
  override readonly operator = input.required<'equals' | 'notEquals'>();
  override readonly dataService = input.required<PageFilterDataService<T>>();
  override readonly queryFilter = input.required<QueryFilter<T> | null>();

  getFilterValue(): Filter<T> {
    throw new Error('Method not implemented.');
  }

}
